//
// import React, { useState, useEffect } from 'react';
// import RecipeDetail from './RecipeDetail';
// import CommentsModal from './CommentsModel'; // New component
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
// import useBookmarks from './useBookmarks';
//
// const RecipeList = ({ recipes, onRecipeDetailToggle }) => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const [selectedRecipe, setSelectedRecipe] = useState(null);
//     const [selectedCategory, setSelectedCategory] = useState('All');
//     const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);
//
//     // ✅ NEW: Comments modal state
//     const [showCommentsModal, setShowCommentsModal] = useState(false);
//     const [commentsRecipe, setCommentsRecipe] = useState(null);
//
//     const { isBookmarked, toggleBookmark, bookmarkCount } = useBookmarks();
//     const itemsPerPage = 12;
//
//     // Extract unique categories
//     const categories = [
//         'All',
//         ...new Set(
//             recipes.map((recipe) => recipe.categoryName || recipe.categoryId).filter(Boolean)
//         ),
//     ];
//
//     // Filter recipes
//     const filteredRecipes = recipes.filter((recipe) => {
//         const matchesCategory =
//             selectedCategory === 'All' ||
//             (recipe.categoryName || recipe.categoryId) === selectedCategory;
//
//         const matchesBookmark = showBookmarksOnly
//             ? isBookmarked(recipe.recipeId)
//             : true;
//
//         return matchesCategory && matchesBookmark;
//     });
//
//     useEffect(() => {
//         setCurrentPage(1);
//     }, [selectedCategory, showBookmarksOnly]);
//
//     // ✅ NEW: Handle comments modal
//     const handleOpenComments = (e, recipe) => {
//         e.stopPropagation();
//         setCommentsRecipe(recipe);
//         setShowCommentsModal(true);
//     };
//
//     const handleCloseComments = () => {
//         setShowCommentsModal(false);
//         setCommentsRecipe(null);
//     };
//
//     const handleSelectRecipe = (recipe) => {
//         setSelectedRecipe(recipe);
//         onRecipeDetailToggle(true);
//     };
//
//     const handleBack = () => {
//         setSelectedRecipe(null);
//         onRecipeDetailToggle(false);
//     };
//
//     if (selectedRecipe) {
//         return (
//             <RecipeDetail
//                 recipe={selectedRecipe}
//                 onBack={handleBack}
//                 isBookmarked={isBookmarked(selectedRecipe.recipeId)}
//                 onToggleBookmark={() => toggleBookmark(selectedRecipe)}
//             />
//         );
//     }
//
//     // Pagination
//     const totalPages = Math.ceil(filteredRecipes.length / itemsPerPage);
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentRecipes = filteredRecipes.slice(indexOfFirstItem, indexOfLastItem);
//
//     const getApplianceLink = (categoryName) => {
//         const applianceLinks = {
//             'Nutri Blender': 'https://www.crompton.co.in/collections/mixer-grinder-and-blender',
//             'Air Fryer': 'https://www.crompton.co.in/collections/air-fryer',
//             'OTG': 'https://www.crompton.co.in/collections/cooking-appliances',
//         };
//         return applianceLinks[categoryName] || 'https://www.crompton.co.in/';
//     };
//
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };
//
//     const handleNext = () => {
//         if (currentPage < totalPages) {
//             setCurrentPage(currentPage + 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     const handlePrevious = () => {
//         if (currentPage > 1) {
//             setCurrentPage(currentPage - 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     // ✅ NEW: Star rating component
//     const StarRating = ({ rating, totalRatings }) => {
//         const fullStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;
//         const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//
//         return (
//             <div className="flex items-center gap-2">
//                 <div className="flex items-center gap-0.5">
//                     {/* Full Stars */}
//                     {[...Array(fullStars)].map((_, i) => (
//                         <svg
//                             key={`full-${i}`}
//                             className="w-4 h-4 text-yellow-400 fill-current"
//                             viewBox="0 0 20 20"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//
//                     {/* Half Star */}
//                     {hasHalfStar && (
//                         <svg
//                             className="w-4 h-4 text-yellow-400"
//                             viewBox="0 0 20 20"
//                         >
//                             <defs>
//                                 <linearGradient id="half-fill">
//                                     <stop offset="50%" stopColor="currentColor" />
//                                     <stop offset="50%" stopColor="transparent" />
//                                 </linearGradient>
//                             </defs>
//                             <path
//                                 fill="url(#half-fill)"
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                             <path
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="0.5"
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                         </svg>
//                     )}
//
//                     {/* Empty Stars */}
//                     {[...Array(emptyStars)].map((_, i) => (
//                         <svg
//                             key={`empty-${i}`}
//                             className="w-4 h-4 text-gray-300 dark:text-gray-600"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//                 </div>
//
//                 <div className="flex items-center gap-1 text-xs">
//                     <span className="font-bold text-gray-700 dark:text-gray-300">
//                         {rating.toFixed(1)}
//                     </span>
//                     <span className="text-gray-500 dark:text-gray-400">
//                         ({totalRatings})
//                     </span>
//                 </div>
//             </div>
//         );
//     };
//
//     return (
//         <div className="w-full">
//             {/* Category Filter Section - Same as before */}
//             <div className="mb-8">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//                     <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
//                         Browse by Category
//                     </h2>
//
//                     <button
//                         onClick={() => {
//                             setShowBookmarksOnly((prev) => !prev);
//                             setSelectedCategory('All');
//                         }}
//                         className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition duration-200 w-full sm:w-auto justify-center sm:justify-start
//                         ${showBookmarksOnly
//                             ? 'bg-yellow-400 border-yellow-400 text-white shadow-lg'
//                             : 'bg-white border-gray-300 text-gray-700 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                         }`}
//                     >
//                         <svg
//                             className={`w-5 h-5 transition-all duration-200 flex-shrink-0
//                             ${showBookmarksOnly
//                                 ? 'fill-white stroke-white'
//                                 : 'fill-none stroke-current'
//                             }`}
//                             viewBox="0 0 24 24"
//                             strokeWidth={2}
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                             />
//                         </svg>
//                         <span>Saved Recipes</span>
//                         {bookmarkCount > 0 && (
//                             <span
//                                 className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0
//                                 ${showBookmarksOnly
//                                     ? 'bg-white text-yellow-500'
//                                     : 'bg-yellow-400 text-white'
//                                 }`}
//                             >
//                                 {bookmarkCount}
//                             </span>
//                         )}
//                     </button>
//                 </div>
//
//                 {!showBookmarksOnly && (
//                     <div className="flex flex-wrap gap-3">
//                         {categories.map((category, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => setSelectedCategory(category)}
//                                 className={`px-6 py-3 rounded-xl font-semibold transition duration-200 ${
//                                     selectedCategory === category
//                                         ? 'bg-[#004c86] text-white dark:text-gray-900 shadow-lg transform scale-105 dark:bg-white'
//                                         : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white'
//                                 }`}
//                             >
//                                 {category}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//             </div>
//
//             {/* Recipe Count Info - Same as before */}
//             <div className="mb-3 flex items-center justify-between">
//                 <p className="text-lg text-gray-600 dark:text-gray-400">
//                     {showBookmarksOnly ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             saved recipes
//                         </>
//                     ) : selectedCategory === 'All' ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes
//                         </>
//                     ) : (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes in{' '}
//                             <span className="font-bold text-[#004c86] dark:text-white">
//                                 {selectedCategory}
//                             </span>
//                         </>
//                     )}
//                 </p>
//             </div>
//
//             {/* Appliance Promo Banner - Same as before */}
//             {!showBookmarksOnly && selectedCategory !== 'All' && (
//                 <div className="mb-6 bg-gradient-to-r from-[#004c86] to-[#0062a8] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
//                     <div className="flex items-center gap-4">
//                         <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
//                             <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
//                                 <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                             </svg>
//                         </div>
//                         <div className="text-white">
//                             <h3 className="font-bold text-lg">
//                                 Make all {selectedCategory} recipes with Crompton
//                             </h3>
//                             <p className="text-sm text-white/80">
//                                 Get the perfect appliance for your kitchen
//                             </p>
//                         </div>
//                     </div>
//                     <a
//                         href={getApplianceLink(selectedCategory)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="bg-white text-[#004c86] px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap w-full md:w-auto text-center"
//                     >
//                         Shop {selectedCategory} →
//                     </a>
//                 </div>
//             )}
//
//             {/* ✅ ENHANCED: Recipe Cards Grid with Ratings & Comments */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
//                 {currentRecipes.map((recipe, index) => (
//                     <div
//                         key={index}
//                         className="flex flex-col bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl dark:bg-navy-800 dark:border-navy-700"
//                     >
//                         {/* Recipe Image */}
//                         <div className="relative w-full h-48 sm:h-52 md:h-56 bg-gray-100 dark:bg-navy-700">
//                             <img
//                                 className="w-full h-full object-cover"
//                                 src={recipe.imageUrl !== null ? recipe.imageUrl : NoImageFound}
//                                 alt={recipe.recipeName || 'Recipe'}
//                             />
//                             {/* Category Badge */}
//                             <div className="absolute top-3 right-3 bg-[#004c86] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[60%] truncate">
//                                 {recipe.categoryName}
//                             </div>
//                         </div>
//
//                         {/* Card Content */}
//                         <div className="flex flex-col p-4 sm:p-5 flex-grow">
//
//                             {/* Title Row: Recipe Name + Bookmark */}
//                             <div className="flex items-start justify-between gap-2 mb-3">
//                                 <h3 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white line-clamp-2 min-h-[2.8rem] sm:min-h-[3.5rem] flex-1 leading-snug">
//                                     {recipe.recipeName}
//                                 </h3>
//
//                                 <button
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         toggleBookmark(recipe);
//                                     }}
//                                     title={isBookmarked(recipe.recipeId) ? 'Remove Bookmark' : 'Save Recipe'}
//                                     className={`
//                                         flex-shrink-0
//                                         flex items-center justify-center
//                                         w-8 h-8 sm:w-9 sm:h-9
//                                         rounded-lg
//                                         mt-0.5
//                                         transition-all duration-200
//                                         shadow-sm
//                                         ${isBookmarked(recipe.recipeId)
//                                         ? 'bg-yellow-400 hover:bg-yellow-500 shadow-yellow-200 dark:shadow-yellow-900'
//                                         : 'bg-gray-100 hover:bg-yellow-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600'
//                                     }
//                                     `}
//                                 >
//                                     <svg
//                                         className={`
//                                             w-4 h-4
//                                             transition-all duration-200
//                                             ${isBookmarked(recipe.recipeId)
//                                             ? 'fill-white stroke-white'
//                                             : 'fill-none stroke-gray-500 dark:stroke-gray-300'
//                                         }
//                                         `}
//                                         viewBox="0 0 24 24"
//                                         strokeWidth={2.5}
//                                     >
//                                         <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                         />
//                                     </svg>
//                                 </button>
//                             </div>
//
//                             {/* Recipe Details */}
//                             <div className="flex flex-col gap-1.5 mb-3 text-sm">
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🍽️ Servings:</span>
//                                     <span>{recipe.servings}</span>
//                                 </div>
//                                 {recipe.prepTime && (
//                                     <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                         <span className="font-semibold">⏱️ Prep Time:</span>
//                                         <span>{recipe.prepTime}</span>
//                                     </div>
//                                 )}
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🔥 Cook Time:</span>
//                                     <span>{recipe.cookTime}</span>
//                                 </div>
//                             </div>
//
//                             {/* ✅ NEW: Rating Section */}
//                             <div className="mb-3 pb-3 border-b border-gray-200 dark:border-navy-600">
//                                 <StarRating
//                                     rating={recipe.rating || 0}
//                                     totalRatings={recipe.totalRatings || 0}
//                                 />
//                             </div>
//
//                             {/* ✅ NEW: Comments Preview Button */}
//                             <button
//                                 onClick={(e) => handleOpenComments(e, recipe)}
//                                 className="mb-3 flex items-center justify-between px-3 py-2 rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-navy-700 dark:hover:bg-navy-600 transition-colors border border-gray-200 dark:border-navy-600"
//                             >
//                                 <div className="flex items-center gap-2 text-sm">
//                                     <svg
//                                         className="w-4 h-4 text-gray-600 dark:text-gray-300"
//                                         fill="none"
//                                         viewBox="0 0 24 24"
//                                         stroke="currentColor"
//                                     >
//                                         <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             strokeWidth={2}
//                                             d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//                                         />
//                                     </svg>
//                                     <span className="font-medium text-gray-700 dark:text-gray-200">
//                                         {recipe.commentsCount || 0} Comments
//                                     </span>
//                                 </div>
//                                 <svg
//                                     className="w-4 h-4 text-gray-400"
//                                     fill="none"
//                                     viewBox="0 0 24 24"
//                                     stroke="currentColor"
//                                 >
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth={2}
//                                         d="M9 5l7 7-7 7"
//                                     />
//                                 </svg>
//                             </button>
//
//                             {/* View Recipe Button */}
//                             <button
//                                 onClick={() => handleSelectRecipe(recipe)}
//                                 className="mt-auto w-full rounded-xl border-2 border-[#004c86] px-4 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-[#004c86] transition duration-200 hover:bg-[#004c80] hover:text-white active:bg-[#004c86] dark:border-white dark:text-white dark:hover:bg-[#004c86] dark:hover:text-white"
//                             >
//                                 View Recipe
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//
//             {/* Empty State - Same as before */}
//             {filteredRecipes.length === 0 && (
//                 <div className="text-center py-16">
//                     {showBookmarksOnly ? (
//                         <div className="flex flex-col items-center gap-4 px-4">
//                             <svg
//                                 className="w-16 h-16 text-gray-300 dark:text-gray-600"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={1.5}
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
//                                 No saved recipes yet!
//                             </p>
//                             <p className="text-sm text-gray-400 dark:text-gray-500 max-w-xs">
//                                 Click the 🔖 icon on any recipe card to save it here.
//                             </p>
//                             <button
//                                 onClick={() => setShowBookmarksOnly(false)}
//                                 className="mt-2 px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                             >
//                                 Browse Recipes
//                             </button>
//                         </div>
//                     ) : (
//                         <p className="text-xl text-gray-500 dark:text-gray-400">
//                             No recipes found!!
//                         </p>
//                     )}
//                 </div>
//             )}
//
//             {/* Pagination - Same as before */}
//             {filteredRecipes.length > itemsPerPage && (
//                 <>
//                     <div className="flex items-center justify-center gap-1 sm:gap-2 mt-8 flex-wrap">
//                         <button
//                             onClick={handlePrevious}
//                             disabled={currentPage === 1}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === 1
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Previous
//                         </button>
//
//                         <div className="flex gap-1 sm:gap-2 flex-wrap justify-center">
//                             {[...Array(totalPages)].map((_, index) => {
//                                 const pageNumber = index + 1;
//                                 if (
//                                     pageNumber === 1 ||
//                                     pageNumber === totalPages ||
//                                     (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
//                                 ) {
//                                     return (
//                                         <button
//                                             key={pageNumber}
//                                             onClick={() => handlePageChange(pageNumber)}
//                                             className={`w-9 h-9 rounded-lg font-medium transition duration-200 text-sm
//                                             ${currentPage === pageNumber
//                                                 ? 'bg-[#004c86] text-white'
//                                                 : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:bg-navy-700'
//                                             }`}
//                                         >
//                                             {pageNumber}
//                                         </button>
//                                     );
//                                 } else if (
//                                     pageNumber === currentPage - 2 ||
//                                     pageNumber === currentPage + 2
//                                 ) {
//                                     return (
//                                         <span
//                                             key={pageNumber}
//                                             className="w-9 h-9 flex items-center justify-center text-gray-500 dark:text-gray-400 text-sm"
//                                         >
//                                             ...
//                                         </span>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>
//
//                         <button
//                             onClick={handleNext}
//                             disabled={currentPage === totalPages}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === totalPages
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Next
//                         </button>
//                     </div>
//
//                     <div className="text-center mt-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
//                         Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredRecipes.length)} of {filteredRecipes.length} recipes
//                     </div>
//                 </>
//             )}
//
//             {/* ✅ NEW: Comments Modal */}
//             {showCommentsModal && commentsRecipe && (
//                 <CommentsModal
//                     recipe={commentsRecipe}
//                     onClose={handleCloseComments}
//                 />
//             )}
//         </div>
//     );
// };
//
// export default RecipeList;

// import React, { useState, useEffect } from 'react';
// import RecipeDetail from './RecipeDetail';
// import CommentsModal from './CommentsModel';
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
// import useBookmarks from './useBookmarks';
//
// const RecipeList = ({ recipes, onRecipeDetailToggle }) => {
//     const [currentPage, setCurrentPage] = useState(1);
//     const [selectedRecipe, setSelectedRecipe] = useState(null);
//     const [selectedCategory, setSelectedCategory] = useState('All');
//     const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);
//
//     // ✅ Comments modal state
//     const [showCommentsModal, setShowCommentsModal] = useState(false);
//     const [commentsRecipe, setCommentsRecipe] = useState(null);
//
//     const { isBookmarked, toggleBookmark, bookmarkCount } = useBookmarks();
//     const itemsPerPage = 12;
//
//     // Extract unique categories
//     const categories = [
//         'All',
//         ...new Set(
//             recipes.map((recipe) => recipe.categoryName || recipe.categoryId).filter(Boolean)
//         ),
//     ];
//
//     // Filter recipes
//     const filteredRecipes = recipes.filter((recipe) => {
//         const matchesCategory =
//             selectedCategory === 'All' ||
//             (recipe.categoryName || recipe.categoryId) === selectedCategory;
//
//         const matchesBookmark = showBookmarksOnly
//             ? isBookmarked(recipe.recipeId)
//             : true;
//
//         return matchesCategory && matchesBookmark;
//     });
//
//     useEffect(() => {
//         setCurrentPage(1);
//     }, [selectedCategory, showBookmarksOnly]);
//
//     // Handle comments modal
//     const handleOpenComments = (e, recipe) => {
//         e.stopPropagation();
//         setCommentsRecipe(recipe);
//         setShowCommentsModal(true);
//     };
//
//     const handleCloseComments = () => {
//         setShowCommentsModal(false);
//         setCommentsRecipe(null);
//     };
//
//     const handleSelectRecipe = (recipe) => {
//         setSelectedRecipe(recipe);
//         onRecipeDetailToggle(true);
//     };
//
//     const handleBack = () => {
//         setSelectedRecipe(null);
//         onRecipeDetailToggle(false);
//     };
//
//     if (selectedRecipe) {
//         return (
//             <RecipeDetail
//                 recipe={selectedRecipe}
//                 onBack={handleBack}
//                 isBookmarked={isBookmarked(selectedRecipe.recipeId)}
//                 onToggleBookmark={() => toggleBookmark(selectedRecipe)}
//             />
//         );
//     }
//
//     // Pagination
//     const totalPages = Math.ceil(filteredRecipes.length / itemsPerPage);
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentRecipes = filteredRecipes.slice(indexOfFirstItem, indexOfLastItem);
//
//     const getApplianceLink = (categoryName) => {
//         const applianceLinks = {
//             'Nutri Blender': 'https://www.crompton.co.in/collections/mixer-grinder-and-blender',
//             'Air Fryer': 'https://www.crompton.co.in/collections/air-fryer',
//             'OTG': 'https://www.crompton.co.in/collections/cooking-appliances',
//         };
//         return applianceLinks[categoryName] || 'https://www.crompton.co.in/';
//     };
//
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };
//
//     const handleNext = () => {
//         if (currentPage < totalPages) {
//             setCurrentPage(currentPage + 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     const handlePrevious = () => {
//         if (currentPage > 1) {
//             setCurrentPage(currentPage - 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     // ✅ Star rating component (compact version for inline display)
//     const StarRating = ({ rating, totalRatings }) => {
//         const fullStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;
//         const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//
//         return (
//             <div className="flex items-center gap-2">
//                 <div className="flex items-center gap-0.5">
//                     {/* Full Stars */}
//                     {[...Array(fullStars)].map((_, i) => (
//                         <svg
//                             key={`full-${i}`}
//                             className="w-4 h-4 text-yellow-400 fill-current"
//                             viewBox="0 0 20 20"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//
//                     {/* Half Star */}
//                     {hasHalfStar && (
//                         <svg
//                             className="w-4 h-4 text-yellow-400"
//                             viewBox="0 0 20 20"
//                         >
//                             <defs>
//                                 <linearGradient id={`half-fill-${rating}`}>
//                                     <stop offset="50%" stopColor="currentColor" />
//                                     <stop offset="50%" stopColor="transparent" />
//                                 </linearGradient>
//                             </defs>
//                             <path
//                                 fill={`url(#half-fill-${rating})`}
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                             <path
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="0.5"
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                         </svg>
//                     )}
//
//                     {/* Empty Stars */}
//                     {[...Array(emptyStars)].map((_, i) => (
//                         <svg
//                             key={`empty-${i}`}
//                             className="w-4 h-4 text-gray-300 dark:text-gray-600"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//                 </div>
//
//                 <div className="flex items-center gap-1 text-xs">
//                     <span className="font-bold text-gray-700 dark:text-gray-300">
//                         {rating.toFixed(1)}
//                     </span>
//                     <span className="text-gray-500 dark:text-gray-400">
//                         ({totalRatings})
//                     </span>
//                 </div>
//             </div>
//         );
//     };
//
//     return (
//         <div className="w-full">
//             {/* Category Filter Section */}
//             <div className="mb-8">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//                     <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
//                         Browse by Category
//                     </h2>
//
//                     <button
//                         onClick={() => {
//                             setShowBookmarksOnly((prev) => !prev);
//                             setSelectedCategory('All');
//                         }}
//                         className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition duration-200 w-full sm:w-auto justify-center sm:justify-start
//                         ${showBookmarksOnly
//                             ? 'bg-yellow-400 border-yellow-400 text-white shadow-lg'
//                             : 'bg-white border-gray-300 text-gray-700 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                         }`}
//                     >
//                         <svg
//                             className={`w-5 h-5 transition-all duration-200 flex-shrink-0
//                             ${showBookmarksOnly
//                                 ? 'fill-white stroke-white'
//                                 : 'fill-none stroke-current'
//                             }`}
//                             viewBox="0 0 24 24"
//                             strokeWidth={2}
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                             />
//                         </svg>
//                         <span>Saved Recipes</span>
//                         {bookmarkCount > 0 && (
//                             <span
//                                 className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0
//                                 ${showBookmarksOnly
//                                     ? 'bg-white text-yellow-500'
//                                     : 'bg-yellow-400 text-white'
//                                 }`}
//                             >
//                                 {bookmarkCount}
//                             </span>
//                         )}
//                     </button>
//                 </div>
//
//                 {!showBookmarksOnly && (
//                     <div className="flex flex-wrap gap-3">
//                         {categories.map((category, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => setSelectedCategory(category)}
//                                 className={`px-6 py-3 rounded-xl font-semibold transition duration-200 ${
//                                     selectedCategory === category
//                                         ? 'bg-[#004c86] text-white dark:text-gray-900 shadow-lg transform scale-105 dark:bg-white'
//                                         : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white'
//                                 }`}
//                             >
//                                 {category}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//             </div>
//
//             {/* Recipe Count Info */}
//             <div className="mb-3 flex items-center justify-between">
//                 <p className="text-lg text-gray-600 dark:text-gray-400">
//                     {showBookmarksOnly ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             saved recipes
//                         </>
//                     ) : selectedCategory === 'All' ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes
//                         </>
//                     ) : (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes in{' '}
//                             <span className="font-bold text-[#004c86] dark:text-white">
//                                 {selectedCategory}
//                             </span>
//                         </>
//                     )}
//                 </p>
//             </div>
//
//             {/* Appliance Promo Banner */}
//             {!showBookmarksOnly && selectedCategory !== 'All' && (
//                 <div className="mb-6 bg-gradient-to-r from-[#004c86] to-[#0062a8] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
//                     <div className="flex items-center gap-4">
//                         <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
//                             <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
//                                 <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                             </svg>
//                         </div>
//                         <div className="text-white">
//                             <h3 className="font-bold text-lg">
//                                 Make all {selectedCategory} recipes with Crompton
//                             </h3>
//                             <p className="text-sm text-white/80">
//                                 Get the perfect appliance for your kitchen
//                             </p>
//                         </div>
//                     </div>
//                     <a
//                         href={getApplianceLink(selectedCategory)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="bg-white text-[#004c86] px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap w-full md:w-auto text-center"
//                     >
//                         Shop {selectedCategory} →
//                     </a>
//                 </div>
//             )}
//
//             {/* ✅ NEW LAYOUT: Recipe Cards Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
//                 {currentRecipes.map((recipe, index) => (
//                     <div
//                         key={index}
//                         className="flex flex-col bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl dark:bg-navy-800 dark:border-navy-700"
//                     >
//                         {/* Recipe Image */}
//                         <div className="relative w-full h-48 sm:h-52 md:h-56 bg-gray-100 dark:bg-navy-700">
//                             <img
//                                 className="w-full h-full object-cover"
//                                 src={recipe.imageUrl !== null ? recipe.imageUrl : NoImageFound}
//                                 alt={recipe.recipeName || 'Recipe'}
//                             />
//                             {/* Category Badge */}
//                             <div className="absolute top-3 right-3 bg-[#004c86] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[60%] truncate">
//                                 {recipe.categoryName}
//                             </div>
//                         </div>
//
//                         {/* Card Content */}
//                         <div className="flex flex-col p-4 sm:p-5 flex-grow">
//
//                             {/* ✅ NEW: Title Row with Recipe Name, Comment Icon, and Bookmark */}
//                             <div className="flex items-start justify-between gap-2 mb-2">
//                                 <h3 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white line-clamp-2 flex-1 leading-snug">
//                                     {recipe.recipeName}
//                                 </h3>
//
//                                 <div className="flex items-start gap-1.5 flex-shrink-0">
//                                     {/* ✅ NEW: Comment Icon with Hover Effect */}
//                                     <button
//                                         onClick={(e) => handleOpenComments(e, recipe)}
//                                         title={`View ${recipe.commentsCount || 0} comments`}
//                                         className="group relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-gray-100 hover:bg-blue-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600 transition-all duration-200 shadow-sm"
//                                     >
//                                         <svg
//                                             className="w-4 h-4 text-gray-600 dark:text-gray-300 group-hover:text-[#004c86] dark:group-hover:text-white transition-all duration-200 group-hover:scale-125"
//                                             fill="none"
//                                             viewBox="0 0 24 24"
//                                             stroke="currentColor"
//                                         >
//                                             <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 strokeWidth={2}
//                                                 d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//                                             />
//                                         </svg>
//
//                                         {/* Comment Count Badge */}
//                                         {recipe.commentsCount > 0 && (
//                                             <span className="absolute -top-1 -right-1 bg-[#004c86] text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center dark:bg-white dark:text-[#004c86]">
//                                                 {recipe.commentsCount > 9 ? '9+' : recipe.commentsCount}
//                                             </span>
//                                         )}
//                                     </button>
//
//                                     {/* Bookmark Button */}
//                                     <button
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             toggleBookmark(recipe);
//                                         }}
//                                         title={isBookmarked(recipe.recipeId) ? 'Remove Bookmark' : 'Save Recipe'}
//                                         className={`
//                                             flex items-center justify-center
//                                             w-8 h-8 sm:w-9 sm:h-9
//                                             rounded-lg
//                                             transition-all duration-200
//                                             shadow-sm
//                                             ${isBookmarked(recipe.recipeId)
//                                             ? 'bg-yellow-400 hover:bg-yellow-500 shadow-yellow-200 dark:shadow-yellow-900'
//                                             : 'bg-gray-100 hover:bg-yellow-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600'
//                                         }
//                                         `}
//                                     >
//                                         <svg
//                                             className={`
//                                                 w-4 h-4
//                                                 transition-all duration-200
//                                                 ${isBookmarked(recipe.recipeId)
//                                                 ? 'fill-white stroke-white'
//                                                 : 'fill-none stroke-gray-500 dark:stroke-gray-300'
//                                             }
//                                             `}
//                                             viewBox="0 0 24 24"
//                                             strokeWidth={2.5}
//                                         >
//                                             <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                             />
//                                         </svg>
//                                     </button>
//                                 </div>
//                             </div>
//
//                             {/* ✅ NEW: Rating Below Recipe Name */}
//                             <div className="mb-3">
//                                 <StarRating
//                                     rating={recipe.rating || 0}
//                                     totalRatings={recipe.totalRatings || 0}
//                                 />
//                             </div>
//
//                             {/* Recipe Details */}
//                             <div className="flex flex-col gap-1.5 mb-4 text-sm">
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🍽️ Servings:</span>
//                                     <span>{recipe.servings}</span>
//                                 </div>
//                                 {recipe.prepTime && (
//                                     <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                         <span className="font-semibold">⏱️ Prep Time:</span>
//                                         <span>{recipe.prepTime}</span>
//                                     </div>
//                                 )}
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🔥 Cook Time:</span>
//                                     <span>{recipe.cookTime}</span>
//                                 </div>
//                             </div>
//
//                             {/* View Recipe Button */}
//                             <button
//                                 onClick={() => handleSelectRecipe(recipe)}
//                                 className="mt-auto w-full rounded-xl border-2 border-[#004c86] px-4 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-[#004c86] transition duration-200 hover:bg-[#004c80] hover:text-white active:bg-[#004c86] dark:border-white dark:text-white dark:hover:bg-[#004c86] dark:hover:text-white"
//                             >
//                                 View Recipe
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//
//             {/* Empty State */}
//             {filteredRecipes.length === 0 && (
//                 <div className="text-center py-16">
//                     {showBookmarksOnly ? (
//                         <div className="flex flex-col items-center gap-4 px-4">
//                             <svg
//                                 className="w-16 h-16 text-gray-300 dark:text-gray-600"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={1.5}
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
//                                 No saved recipes yet!
//                             </p>
//                             <p className="text-sm text-gray-400 dark:text-gray-500 max-w-xs">
//                                 Click the 🔖 icon on any recipe card to save it here.
//                             </p>
//                             <button
//                                 onClick={() => setShowBookmarksOnly(false)}
//                                 className="mt-2 px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                             >
//                                 Browse Recipes
//                             </button>
//                         </div>
//                     ) : (
//                         <p className="text-xl text-gray-500 dark:text-gray-400">
//                             No recipes found!!
//                         </p>
//                     )}
//                 </div>
//             )}
//
//             {/* Pagination */}
//             {filteredRecipes.length > itemsPerPage && (
//                 <>
//                     <div className="flex items-center justify-center gap-1 sm:gap-2 mt-8 flex-wrap">
//                         <button
//                             onClick={handlePrevious}
//                             disabled={currentPage === 1}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === 1
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Previous
//                         </button>
//
//                         <div className="flex gap-1 sm:gap-2 flex-wrap justify-center">
//                             {[...Array(totalPages)].map((_, index) => {
//                                 const pageNumber = index + 1;
//                                 if (
//                                     pageNumber === 1 ||
//                                     pageNumber === totalPages ||
//                                     (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
//                                 ) {
//                                     return (
//                                         <button
//                                             key={pageNumber}
//                                             onClick={() => handlePageChange(pageNumber)}
//                                             className={`w-9 h-9 rounded-lg font-medium transition duration-200 text-sm
//                                             ${currentPage === pageNumber
//                                                 ? 'bg-[#004c86] text-white'
//                                                 : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:bg-navy-700'
//                                             }`}
//                                         >
//                                             {pageNumber}
//                                         </button>
//                                     );
//                                 } else if (
//                                     pageNumber === currentPage - 2 ||
//                                     pageNumber === currentPage + 2
//                                 ) {
//                                     return (
//                                         <span
//                                             key={pageNumber}
//                                             className="w-9 h-9 flex items-center justify-center text-gray-500 dark:text-gray-400 text-sm"
//                                         >
//                                             ...
//                                         </span>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>
//
//                         <button
//                             onClick={handleNext}
//                             disabled={currentPage === totalPages}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === totalPages
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Next
//                         </button>
//                     </div>
//
//                     <div className="text-center mt-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
//                         Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredRecipes.length)} of {filteredRecipes.length} recipes
//                     </div>
//                 </>
//             )}
//
//             {/* Comments Modal */}
//             {showCommentsModal && commentsRecipe && (
//                 <CommentsModal
//                     recipe={commentsRecipe}
//                     onClose={handleCloseComments}
//                 />
//             )}
//         </div>
//     );
// };
//
// export default RecipeList;
//
// import React, { useState, useEffect } from 'react';
// import RecipeDetail from './RecipeDetail';
// // import CommentsModal from './CommentsModel'; // ✅ COMMENTED OUT
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
// import useBookmarks from './useBookmarks';
// import {useUserAuth} from "../../../../context/UserAuthContext";
// import { AES, enc } from 'crypto-js';
//
// const RecipeList = ({ onRecipeDetailToggle, AllRecipe }) => {  // ✅ Added AllRecipe prop
//     const [currentPage, setCurrentPage] = useState(1);
//     const [selectedRecipe, setSelectedRecipe] = useState(null);
//     const [selectedCategory, setSelectedCategory] = useState('All');
//     const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);
//     const [decryptedToken, setDecryptedToken] = useState(null);
//
//     // ✅ State for recipes and ratings
//     const [recipes, setRecipes] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//
//     const { Token } = useUserAuth();
//     const API_BASE_URL = process.env.REACT_APP_CROMPTON_SENZE_RECIPE_URL;
//     const secretKey = "cromptonssecretkey";
//     const { isBookmarked, toggleBookmark, bookmarkCount } = useBookmarks();
//
//     const itemsPerPage = 12;
//
//     // ✅ SessionStorage keys
//     const RECIPES_CACHE_KEY = 'crompton_recipes_cache';
//     const CACHE_TIMESTAMP_KEY = 'crompton_recipes_cache_timestamp';
//     const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
//
//     // ✅ Decrypt token on component mount or when Token changes
//     useEffect(() => {
//         if (Token) {
//             try {
//                 const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
//                 setDecryptedToken(decryptedValue);
//             } catch (error) {
//                 // console.error('Error decrypting token:', error);
//                 setDecryptedToken(null);
//             }
//         } else {
//             setDecryptedToken(null);
//         }
//     }, [Token]);
//
//     // ✅ NEW: Check AllRecipe prop first, then fetch if needed
//     useEffect(() => {
//         if (decryptedToken) {
//             checkAndLoadRecipes();
//         }
//     }, [decryptedToken, AllRecipe]);
//
//     // ✅ NEW: Check AllRecipe variable and load accordingly
//     const checkAndLoadRecipes = () => {
//         // Check if AllRecipe prop exists and is not null/empty
//         if (AllRecipe && AllRecipe !== null && AllRecipe !== '' && AllRecipe !== undefined) {
//             try {
//                 // console.log('📦 Loading recipes from AllRecipe prop');
//
//                 // Parse if it's a string, otherwise use directly
//                 const parsedRecipes = typeof AllRecipe === 'string'
//                     ? JSON.parse(AllRecipe)
//                     : AllRecipe;
//
//                 // Check if it has the expected structure
//                 if (parsedRecipes && parsedRecipes.recipes && Array.isArray(parsedRecipes.recipes)) {
//                     setRecipes(parsedRecipes.recipes);
//
//                     // ✅ Cache the data
//                     cacheRecipes(parsedRecipes.recipes);
//
//                     setLoading(false);
//                 } else if (Array.isArray(parsedRecipes)) {
//                     // If it's directly an array of recipes
//                     setRecipes(parsedRecipes);
//                     cacheRecipes(parsedRecipes);
//                     setLoading(false);
//                 } else {
//                     // console.warn('AllRecipe has unexpected structure, fetching from API');
//                     fetchRecipesFromAPI();
//                 }
//             } catch (error) {
//                 // console.error('Error parsing AllRecipe:', error);
//                 // Fallback to API if parsing fails
//                 fetchRecipesFromAPI();
//             }
//         } else {
//             // AllRecipe is null/empty, fetch from API
//             // console.log('AllRecipe is empty, fetching from API');
//             fetchRecipesFromAPI();
//         }
//     };
//
//     // ✅ Check if cache is valid
//     const isCacheValid = () => {
//         try {
//             const timestamp = sessionStorage.getItem(CACHE_TIMESTAMP_KEY);
//             if (!timestamp) return false;
//
//             const cacheAge = Date.now() - parseInt(timestamp);
//             return cacheAge < CACHE_DURATION;
//         } catch (error) {
//             // console.error('Error checking cache:', error);
//             return false;
//         }
//     };
//
//     // ✅ Get cached recipes
//     const getCachedRecipes = () => {
//         try {
//             const cachedData = sessionStorage.getItem(RECIPES_CACHE_KEY);
//             if (cachedData) {
//                 return JSON.parse(cachedData);
//             }
//         } catch (error) {
//             console.error('Error reading cache:', error);
//         }
//         return null;
//     };
//
//     // ✅ Save recipes to cache
//     const cacheRecipes = (recipesData) => {
//         try {
//             sessionStorage.setItem(RECIPES_CACHE_KEY, JSON.stringify(recipesData));
//             sessionStorage.setItem(CACHE_TIMESTAMP_KEY, Date.now().toString());
//         } catch (error) {
//             console.error('Error saving to cache:', error);
//         }
//     };
//
//     // ✅ Clear cache
//     const clearCache = () => {
//         try {
//             sessionStorage.removeItem(RECIPES_CACHE_KEY);
//             sessionStorage.removeItem(CACHE_TIMESTAMP_KEY);
//         } catch (error) {
//             console.error('Error clearing cache:', error);
//         }
//     };
//
//     // ✅ NEW: Simplified function to fetch from /recipes/V2/all API
//     const fetchRecipesFromAPI = async (forceRefresh = false) => {
//         // ✅ Check cache first (unless force refresh)
//         if (!forceRefresh && isCacheValid()) {
//             const cachedRecipes = getCachedRecipes();
//             if (cachedRecipes) {
//                 // console.log('📦 Loading recipes from sessionStorage cache');
//                 setRecipes(cachedRecipes);
//                 setLoading(false);
//                 return;
//             }
//         }
//
//         // console.log('🌐 Fetching fresh recipes from /recipes/V2/all API');
//         setLoading(true);
//         setError(null);
//
//         try {
//             const response = await fetch(`${API_BASE_URL}recipes/V2/all`, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': decryptedToken,
//                     'Content-Type': 'application/json',
//                 },
//             });
//
//             if (!response.ok) {
//                 throw new Error(`API error! status: ${response.status}`);
//             }
//
//             const data = await response.json();
//
//             if (data.success && data.recipes && Array.isArray(data.recipes)) {
//                 // console.log(`✅ Fetched ${data.recipes.length} recipes from API`);
//
//                 // ✅ The API already includes ratings (avgRating, totalRatingsCount, totalCommentsCount)
//                 // No need to merge from separate API
//                 setRecipes(data.recipes);
//
//                 // ✅ Cache the data
//                 cacheRecipes(data.recipes);
//             } else {
//                 throw new Error(data.message || 'Failed to fetch recipes');
//             }
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             setError(error.message);
//
//             // ✅ On error, try to load from cache as fallback
//             const cachedRecipes = getCachedRecipes();
//             if (cachedRecipes) {
//                 // console.log('⚠️ API failed, loading from cache as fallback');
//                 setRecipes(cachedRecipes);
//                 setError(null); // Clear error since we have cached data
//             }
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     // ✅ Function to manually refresh data
//     const handleRefresh = () => {
//         clearCache();
//         fetchRecipesFromAPI(true);
//     };
//
//     // Extract unique categories
//     const categories = [
//         'All',
//         ...new Set(
//             recipes.map((recipe) => recipe.categoryName || recipe.categoryId).filter(Boolean)
//         ),
//     ];
//
//     // Filter recipes
//     const filteredRecipes = recipes.filter((recipe) => {
//         const matchesCategory =
//             selectedCategory === 'All' ||
//             (recipe.categoryName || recipe.categoryId) === selectedCategory;
//
//         const matchesBookmark = showBookmarksOnly
//             ? isBookmarked(recipe.recipeId)
//             : true;
//
//         return matchesCategory && matchesBookmark;
//     });
//
//     useEffect(() => {
//         setCurrentPage(1);
//     }, [selectedCategory, showBookmarksOnly]);
//
//     // ✅ Handle comments modal - COMMENTED OUT
//     // const handleOpenComments = (e, recipe) => {
//     //     e.stopPropagation();
//     //     setCommentsRecipe(recipe);
//     //     setShowCommentsModal(true);
//     // };
//
//     // const handleCloseComments = () => {
//     //     setShowCommentsModal(false);
//     //     setCommentsRecipe(null);
//     // };
//
//     const handleSelectRecipe = (recipe) => {
//         setSelectedRecipe(recipe);
//         onRecipeDetailToggle(true);
//     };
//
//     const handleBack = () => {
//         setSelectedRecipe(null);
//         onRecipeDetailToggle(false);
//     };
//
//     // ✅ Loading State
//     if (loading) {
//         return (
//             <div className="flex items-center justify-center min-h-[400px]">
//                 <div className="text-center">
//                     <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#004c86] dark:border-white mb-4"></div>
//                     <p className="text-lg text-gray-600 dark:text-gray-400">Loading delicious recipes...</p>
//                 </div>
//             </div>
//         );
//     }
//
//     // ✅ Error State
//     if (error) {
//         return (
//             <div className="flex items-center justify-center min-h-[400px]">
//                 <div className="text-center px-4">
//                     <svg className="w-16 h-16 text-red-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                     </svg>
//                     <p className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">Oops! Something went wrong</p>
//                     <p className="text-gray-500 dark:text-gray-400 mb-4">{error}</p>
//                     <button
//                         onClick={handleRefresh}
//                         className="px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                     >
//                         Try Again
//                     </button>
//                 </div>
//             </div>
//         );
//     }
//
//     if (selectedRecipe) {
//         return (
//             <RecipeDetail
//                 recipe={selectedRecipe}
//                 onBack={handleBack}
//                 isBookmarked={isBookmarked(selectedRecipe.recipeId)}
//                 onToggleBookmark={() => toggleBookmark(selectedRecipe)}
//             />
//         );
//     }
//
//     // Pagination
//     const totalPages = Math.ceil(filteredRecipes.length / itemsPerPage);
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentRecipes = filteredRecipes.slice(indexOfFirstItem, indexOfLastItem);
//
//     const getApplianceLink = (categoryName) => {
//         const applianceLinks = {
//             'Nutri Blender': 'https://www.crompton.co.in/collections/mixer-grinder-and-blender',
//             'Air Fryer': 'https://www.crompton.co.in/collections/air-fryer',
//             'OTG': 'https://www.crompton.co.in/collections/cooking-appliances',
//         };
//         return applianceLinks[categoryName] || 'https://www.crompton.co.in/';
//     };
//
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };
//
//     const handleNext = () => {
//         if (currentPage < totalPages) {
//             setCurrentPage(currentPage + 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     const handlePrevious = () => {
//         if (currentPage > 1) {
//             setCurrentPage(currentPage - 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     // ✅ Star rating component
//     const StarRating = ({ rating, totalRatings }) => {
//         const validRating = typeof rating === 'number' && !isNaN(rating) ? rating : 0;
//         const validTotal = typeof totalRatings === 'number' && !isNaN(totalRatings) ? totalRatings : 0;
//
//         const fullStars = Math.floor(validRating);
//         const hasHalfStar = validRating % 1 >= 0.5;
//         const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//
//         return (
//             <div className="flex items-center gap-2">
//                 <div className="flex items-center gap-0.5">
//                     {[...Array(fullStars)].map((_, i) => (
//                         <svg
//                             key={`full-${i}`}
//                             className="w-4 h-4 text-yellow-400 fill-current"
//                             viewBox="0 0 20 20"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//
//                     {hasHalfStar && (
//                         <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 20 20">
//                             <defs>
//                                 <linearGradient id={`half-fill-${validRating}`}>
//                                     <stop offset="50%" stopColor="currentColor" />
//                                     <stop offset="50%" stopColor="transparent" />
//                                 </linearGradient>
//                             </defs>
//                             <path
//                                 fill={`url(#half-fill-${validRating})`}
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                             <path
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="0.5"
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                         </svg>
//                     )}
//
//                     {[...Array(emptyStars)].map((_, i) => (
//                         <svg
//                             key={`empty-${i}`}
//                             className="w-4 h-4 text-gray-300 dark:text-gray-600"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//                 </div>
//
//                 <div className="flex items-center gap-1 text-xs">
//                     <span className="font-bold text-gray-700 dark:text-gray-300">
//                         {validRating > 0 ? validRating.toFixed(1) : '0.0'}
//                     </span>
//                     <span className="text-gray-500 dark:text-gray-400">
//                         ({validTotal})
//                     </span>
//                 </div>
//             </div>
//         );
//     };
//
//     return (
//         <div className="w-full">
//             {/* Category Filter Section */}
//             <div className="mb-8">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//                     <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
//                         Browse by Category
//                     </h2>
//
//                     <div className="flex gap-2 w-full sm:w-auto">
//                         {/* ✅ Refresh Button */}
//                         <button
//                             onClick={handleRefresh}
//                             title="Refresh recipes"
//                             className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold border-2 border-gray-300 bg-white text-gray-700 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white transition duration-200"
//                         >
//                             <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                             </svg>
//                             <span className="hidden sm:inline">Refresh</span>
//                         </button>
//
//                         <button
//                             onClick={() => {
//                                 setShowBookmarksOnly((prev) => !prev);
//                                 setSelectedCategory('All');
//                             }}
//                             className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition duration-200 flex-1 sm:flex-initial justify-center sm:justify-start
//                             ${showBookmarksOnly
//                                 ? 'bg-yellow-400 border-yellow-400 text-white shadow-lg'
//                                 : 'bg-white border-gray-300 text-gray-700 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                             }`}
//                         >
//                             <svg
//                                 className={`w-5 h-5 transition-all duration-200 flex-shrink-0
//                                 ${showBookmarksOnly
//                                     ? 'fill-white stroke-white'
//                                     : 'fill-none stroke-current'
//                                 }`}
//                                 viewBox="0 0 24 24"
//                                 strokeWidth={2}
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <span>Saved Recipes</span>
//                             {bookmarkCount > 0 && (
//                                 <span
//                                     className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0
//                                     ${showBookmarksOnly
//                                         ? 'bg-white text-yellow-500'
//                                         : 'bg-yellow-400 text-white'
//                                     }`}
//                                 >
//                                     {bookmarkCount}
//                                 </span>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//
//                 {!showBookmarksOnly && (
//                     <div className="flex flex-wrap gap-3">
//                         {categories.map((category, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => setSelectedCategory(category)}
//                                 className={`px-6 py-3 rounded-xl font-semibold transition duration-200 ${
//                                     selectedCategory === category
//                                         ? 'bg-[#004c86] text-white dark:text-gray-900 shadow-lg transform scale-105 dark:bg-white'
//                                         : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white'
//                                 }`}
//                             >
//                                 {category}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//             </div>
//
//             {/* Recipe Count Info */}
//             <div className="mb-3 flex items-center justify-between">
//                 <p className="text-lg text-gray-600 dark:text-gray-400">
//                     {showBookmarksOnly ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             saved recipes
//                         </>
//                     ) : selectedCategory === 'All' ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes
//                         </>
//                     ) : (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes in{' '}
//                             <span className="font-bold text-[#004c86] dark:text-white">
//                                 {selectedCategory}
//                             </span>
//                         </>
//                     )}
//                 </p>
//             </div>
//
//             {/* Appliance Promo Banner */}
//             {!showBookmarksOnly && selectedCategory !== 'All' && (
//                 <div className="mb-6 bg-gradient-to-r from-[#004c86] to-[#0062a8] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
//                     <div className="flex items-center gap-4">
//                         <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
//                             <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
//                                 <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                             </svg>
//                         </div>
//                         <div className="text-white">
//                             <h3 className="font-bold text-lg">
//                                 Make all {selectedCategory} recipes with Crompton
//                             </h3>
//                             <p className="text-sm text-white/80">
//                                 Get the perfect appliance for your kitchen
//                             </p>
//                         </div>
//                     </div>
//                     <a
//                         href={getApplianceLink(selectedCategory)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="bg-white text-[#004c86] px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap w-full md:w-auto text-center"
//                     >
//                         Shop {selectedCategory} →
//                     </a>
//                 </div>
//             )}
//
//             {/* Recipe Cards Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
//                 {currentRecipes.map((recipe, index) => (
//                     <div
//                         key={recipe.recipeId || index}
//                         className="flex flex-col bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl dark:bg-navy-800 dark:border-navy-700"
//                     >
//                         {/* Recipe Image */}
//                         <div className="relative w-full h-48 sm:h-52 md:h-56 bg-gray-100 dark:bg-navy-700">
//                             <img
//                                 className="w-full h-full object-cover"
//                                 src={recipe.imageUrl || NoImageFound}
//                                 alt={recipe.recipeName || 'Recipe'}
//                                 onError={(e) => {
//                                     e.target.src = NoImageFound;
//                                 }}
//                             />
//                             <div className="absolute top-3 right-3 bg-[#004c86] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[60%] truncate">
//                                 {recipe.categoryName}
//                             </div>
//                         </div>
//
//                         {/* Card Content */}
//                         <div className="flex flex-col p-4 sm:p-5 flex-grow">
//                             <div className="flex items-start justify-between gap-2 mb-2">
//                                 <h3 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white line-clamp-2 flex-1 leading-snug">
//                                     {recipe.recipeName}
//                                 </h3>
//
//                                 <div className="flex items-start gap-1.5 flex-shrink-0">
//                                     {/* ✅ Comment Icon - COMMENTED OUT */}
//                                     {/* <button
//                                         onClick={(e) => handleOpenComments(e, recipe)}
//                                         title={`View ${recipe.totalCommentsCount || 0} comments`}
//                                         className="group relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-gray-100 hover:bg-blue-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600 transition-all duration-200 shadow-sm"
//                                     >
//                                         <svg
//                                             className="w-4 h-4 text-gray-600 dark:text-gray-300 group-hover:text-[#004c86] dark:group-hover:text-white transition-all duration-200 group-hover:scale-125"
//                                             fill="none"
//                                             viewBox="0 0 24 24"
//                                             stroke="currentColor"
//                                         >
//                                             <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 strokeWidth={2}
//                                                 d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
//                                             />
//                                         </svg>
//
//                                         {recipe.totalCommentsCount > 0 && (
//                                             <span className="absolute -top-1 -right-1 bg-[#004c86] text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center dark:bg-white dark:text-[#004c86]">
//                                                 {recipe.totalCommentsCount > 9 ? '9+' : recipe.totalCommentsCount}
//                                             </span>
//                                         )}
//                                     </button> */}
//
//                                     {/* Bookmark Button */}
//                                     <button
//                                         onClick={(e) => {
//                                             e.stopPropagation();
//                                             toggleBookmark(recipe);
//                                         }}
//                                         title={isBookmarked(recipe.recipeId) ? 'Remove Bookmark' : 'Save Recipe'}
//                                         className={`
//                                             flex items-center justify-center
//                                             w-8 h-8 sm:w-9 sm:h-9
//                                             rounded-lg
//                                             transition-all duration-200
//                                             shadow-sm
//                                             ${isBookmarked(recipe.recipeId)
//                                             ? 'bg-yellow-400 hover:bg-yellow-500 shadow-yellow-200 dark:shadow-yellow-900'
//                                             : 'bg-gray-100 hover:bg-yellow-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600'
//                                         }
//                                         `}
//                                     >
//                                         <svg
//                                             className={`
//                                                 w-4 h-4
//                                                 transition-all duration-200
//                                                 ${isBookmarked(recipe.recipeId)
//                                                 ? 'fill-white stroke-white'
//                                                 : 'fill-none stroke-gray-500 dark:stroke-gray-300'
//                                             }
//                                             `}
//                                             viewBox="0 0 24 24"
//                                             strokeWidth={2.5}
//                                         >
//                                             <path
//                                                 strokeLinecap="round"
//                                                 strokeLinejoin="round"
//                                                 d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                             />
//                                         </svg>
//                                     </button>
//                                 </div>
//                             </div>
//
//                             {/* ✅ Rating - Using avgRating from /recipes/V2/all API */}
//                             <div className="mb-3">
//                                 <StarRating
//                                     rating={recipe.avgRating || 0}
//                                     totalRatings={recipe.totalRatingsCount || 0}
//                                 />
//                             </div>
//
//                             {/* Recipe Details */}
//                             <div className="flex flex-col gap-1.5 mb-4 text-sm">
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🍽️ Servings:</span>
//                                     <span>{recipe.servings || 'N/A'}</span>
//                                 </div>
//                                 {recipe.prepTime && (
//                                     <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                         <span className="font-semibold">⏱️ Prep Time:</span>
//                                         <span>{recipe.prepTime}</span>
//                                     </div>
//                                 )}
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🔥 Cook Time:</span>
//                                     <span>{recipe.cookTime || 'N/A'}</span>
//                                 </div>
//                             </div>
//
//                             {/* View Recipe Button */}
//                             <button
//                                 onClick={() => handleSelectRecipe(recipe)}
//                                 className="mt-auto w-full rounded-xl border-2 border-[#004c86] px-4 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-[#004c86] transition duration-200 hover:bg-[#004c80] hover:text-white active:bg-[#004c86] dark:border-white dark:text-white dark:hover:bg-[#004c86] dark:hover:text-white"
//                             >
//                                 View Recipe
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//
//             {/* Empty State */}
//             {filteredRecipes.length === 0 && !loading && (
//                 <div className="text-center py-16">
//                     {showBookmarksOnly ? (
//                         <div className="flex flex-col items-center gap-4 px-4">
//                             <svg
//                                 className="w-16 h-16 text-gray-300 dark:text-gray-600"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={1.5}
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
//                                 No saved recipes yet!
//                             </p>
//                             <p className="text-sm text-gray-400 dark:text-gray-500 max-w-xs">
//                                 Click the 🔖 icon on any recipe card to save it here.
//                             </p>
//                             <button
//                                 onClick={() => setShowBookmarksOnly(false)}
//                                 className="mt-2 px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                             >
//                                 Browse Recipes
//                             </button>
//                         </div>
//                     ) : (
//                         <p className="text-xl text-gray-500 dark:text-gray-400">
//                             No recipes found!!
//                         </p>
//                     )}
//                 </div>
//             )}
//
//             {/* Pagination */}
//             {filteredRecipes.length > itemsPerPage && (
//                 <>
//                     <div className="flex items-center justify-center gap-1 sm:gap-2 mt-8 flex-wrap">
//                         <button
//                             onClick={handlePrevious}
//                             disabled={currentPage === 1}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === 1
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Previous
//                         </button>
//
//                         <div className="flex gap-1 sm:gap-2 flex-wrap justify-center">
//                             {[...Array(totalPages)].map((_, index) => {
//                                 const pageNumber = index + 1;
//                                 if (
//                                     pageNumber === 1 ||
//                                     pageNumber === totalPages ||
//                                     (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
//                                 ) {
//                                     return (
//                                         <button
//                                             key={pageNumber}
//                                             onClick={() => handlePageChange(pageNumber)}
//                                             className={`w-9 h-9 rounded-lg font-medium transition duration-200 text-sm
//                                             ${currentPage === pageNumber
//                                                 ? 'bg-[#004c86] text-white'
//                                                 : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:bg-navy-700'
//                                             }`}
//                                         >
//                                             {pageNumber}
//                                         </button>
//                                     );
//                                 } else if (
//                                     pageNumber === currentPage - 2 ||
//                                     pageNumber === currentPage + 2
//                                 ) {
//                                     return (
//                                         <span
//                                             key={pageNumber}
//                                             className="w-9 h-9 flex items-center justify-center text-gray-500 dark:text-gray-400 text-sm"
//                                         >
//                                             ...
//                                         </span>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>
//
//                         <button
//                             onClick={handleNext}
//                             disabled={currentPage === totalPages}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === totalPages
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Next
//                         </button>
//                     </div>
//
//                     <div className="text-center mt-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
//                         Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredRecipes.length)} of {filteredRecipes.length} recipes
//                     </div>
//                 </>
//             )}
//
//             {/* ✅ Comments Modal - COMMENTED OUT (kept for future use) */}
//             {/* {showCommentsModal && commentsRecipe && (
//                 <CommentsModal
//                     recipe={commentsRecipe}
//                     onClose={handleCloseComments}
//                     decryptedToken={decryptedToken}
//                     apiBaseUrl={API_BASE_URL}
//                 />
//             )} */}
//         </div>
//     );
// };
//
// export default RecipeList;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { AES, enc } from 'crypto-js';
// import RecipeDetail from './RecipeDetail';
// import NoImageFound from "../../../../assets/img/nfts/no_image.png";
// import useBookmarks from './useBookmarks';
// import { useUserAuth } from "../../../../context/UserAuthContext";
//
// const RecipeList = ({ onRecipeDetailToggle }) => {
//     const { Token, logOut } = useUserAuth();
//     const navigate = useNavigate();
//     const secretKey = "cromptonssecretkey";
//     const API_BASE_URL = process.env.REACT_APP_CROMPTON_SENZE_RECIPE_URL;
//
//     const [currentPage, setCurrentPage] = useState(1);
//     const [selectedRecipe, setSelectedRecipe] = useState(null);
//     const [selectedCategory, setSelectedCategory] = useState('All');
//     const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);
//     const [decryptedToken, setDecryptedToken] = useState(null);
//
//     const [recipes, setRecipes] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//
//     const { isBookmarked, toggleBookmark, bookmarkCount } = useBookmarks();
//     const itemsPerPage = 12;
//
//     // ✅ Decrypt token
//     useEffect(() => {
//         if (Token) {
//             try {
//                 const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
//                 setDecryptedToken(decryptedValue);
//             } catch (error) {
//                 console.error('Error decrypting token:', error);
//                 setDecryptedToken(null);
//             }
//         } else {
//             setDecryptedToken(null);
//         }
//     }, [Token]);
//
//     // ✅ Logout handler
//     const handleLogOut = async () => {
//         try {
//             await logOut();
//             navigate("/");
//         } catch (error) {
//             console.error('Logout error:', error.message);
//         }
//     };
//
//     // ✅ Fetch recipes from API
//     const fetchRecipes = async () => {
//         if (!decryptedToken) return;
//
//         setLoading(true);
//         setError(null);
//
//         try {
//             const url = `${API_BASE_URL}recipes/V2/all`;
//             const response = await axios.get(url, {
//                 headers: {
//                     Authorization: decryptedToken
//                 }
//             });
//
//             if (response.status === 200) {
//                 if (response.data.success && response.data.recipes && response.data.recipes.length > 0) {
//                     // ✅ Store in sessionStorage
//                     sessionStorage.setItem("AllRecipe", JSON.stringify(response.data.recipes));
//                     setRecipes(response.data.recipes);
//                 } else {
//                     setError('No recipes found');
//                     setRecipes([]);
//                 }
//             } else {
//                 setError('Failed to fetch recipes');
//             }
//         } catch (error) {
//             console.error('Error fetching recipes:', error);
//
//             if (error.response?.status === 401 || error.response?.status === 403) {
//                 handleLogOut();
//             } else {
//                 setError(error.response?.data?.message || 'Failed to fetch recipes');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };
//
//     // ✅ Load recipes on mount
//     useEffect(() => {
//         if (decryptedToken) {
//             const cachedRecipes = sessionStorage.getItem("AllRecipe");
//
//             if (cachedRecipes) {
//                 try {
//                     const parsedRecipes = JSON.parse(cachedRecipes);
//                     setRecipes(parsedRecipes);
//                     setLoading(false);
//                 } catch (error) {
//                     console.error('Error parsing cached recipes:', error);
//                     fetchRecipes();
//                 }
//             } else {
//                 fetchRecipes();
//             }
//         }
//     }, [decryptedToken]);
//
//     // ✅ Refresh handler - clears cache and refetches
//     const handleRefresh = () => {
//         sessionStorage.removeItem("AllRecipe");
//         fetchRecipes();
//     };
//
//     // ✅ Extract unique categories
//     const categories = [
//         'All',
//         ...new Set(
//             recipes.map((recipe) => recipe.categoryName || recipe.categoryId).filter(Boolean)
//         ),
//     ];
//
//     // ✅ Filter recipes
//     const filteredRecipes = recipes.filter((recipe) => {
//         const matchesCategory =
//             selectedCategory === 'All' ||
//             (recipe.categoryName || recipe.categoryId) === selectedCategory;
//
//         const matchesBookmark = showBookmarksOnly
//             ? isBookmarked(recipe.recipeId)
//             : true;
//
//         return matchesCategory && matchesBookmark;
//     });
//
//     // ✅ Reset to page 1 when filters change
//     useEffect(() => {
//         setCurrentPage(1);
//     }, [selectedCategory, showBookmarksOnly]);
//
//     // ✅ Recipe selection handlers
//     const handleSelectRecipe = (recipe) => {
//         setSelectedRecipe(recipe);
//         onRecipeDetailToggle(true);
//     };
//
//     const handleBack = () => {
//         setSelectedRecipe(null);
//         onRecipeDetailToggle(false);
//     };
//
//     // ✅ Pagination
//     const totalPages = Math.ceil(filteredRecipes.length / itemsPerPage);
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentRecipes = filteredRecipes.slice(indexOfFirstItem, indexOfLastItem);
//
//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };
//
//     const handleNext = () => {
//         if (currentPage < totalPages) {
//             setCurrentPage(currentPage + 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     const handlePrevious = () => {
//         if (currentPage > 1) {
//             setCurrentPage(currentPage - 1);
//             window.scrollTo({ top: 0, behavior: 'smooth' });
//         }
//     };
//
//     // ✅ Get appliance link
//     const getApplianceLink = (categoryName) => {
//         const applianceLinks = {
//             'Nutri Blender': 'https://www.crompton.co.in/collections/mixer-grinder-and-blender',
//             'Air Fryer': 'https://www.crompton.co.in/collections/air-fryer',
//             'OTG': 'https://www.crompton.co.in/collections/cooking-appliances',
//         };
//         return applianceLinks[categoryName] || 'https://www.crompton.co.in/';
//     };
//
//     // ✅ Star Rating Component
//     const StarRating = ({ rating, totalRatings }) => {
//         const validRating = typeof rating === 'number' && !isNaN(rating) ? rating : 0;
//         const validTotal = typeof totalRatings === 'number' && !isNaN(totalRatings) ? totalRatings : 0;
//
//         const fullStars = Math.floor(validRating);
//         const hasHalfStar = validRating % 1 >= 0.5;
//         const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//
//         return (
//             <div className="flex items-center gap-2">
//                 <div className="flex items-center gap-0.5">
//                     {[...Array(fullStars)].map((_, i) => (
//                         <svg
//                             key={`full-${i}`}
//                             className="w-4 h-4 text-yellow-400 fill-current"
//                             viewBox="0 0 20 20"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//
//                     {hasHalfStar && (
//                         <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 20 20">
//                             <defs>
//                                 <linearGradient id={`half-fill-${validRating}`}>
//                                     <stop offset="50%" stopColor="currentColor" />
//                                     <stop offset="50%" stopColor="transparent" />
//                                 </linearGradient>
//                             </defs>
//                             <path
//                                 fill={`url(#half-fill-${validRating})`}
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                             <path
//                                 fill="none"
//                                 stroke="currentColor"
//                                 strokeWidth="0.5"
//                                 d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
//                             />
//                         </svg>
//                     )}
//
//                     {[...Array(emptyStars)].map((_, i) => (
//                         <svg
//                             key={`empty-${i}`}
//                             className="w-4 h-4 text-gray-300 dark:text-gray-600"
//                             viewBox="0 0 20 20"
//                             fill="currentColor"
//                         >
//                             <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
//                         </svg>
//                     ))}
//                 </div>
//
//                 <div className="flex items-center gap-1 text-xs">
//                     <span className="font-bold text-gray-700 dark:text-gray-300">
//                         {validRating > 0 ? validRating.toFixed(1) : '0.0'}
//                     </span>
//                     <span className="text-gray-500 dark:text-gray-400">
//                         ({validTotal})
//                     </span>
//                 </div>
//             </div>
//         );
//     };
//
//     // ✅ Loading State
//     if (loading) {
//         return (
//             <div className="flex items-center justify-center min-h-[400px]">
//                 <div className="text-center">
//                     <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#004c86] dark:border-white mb-4"></div>
//                     <p className="text-lg text-gray-600 dark:text-gray-400">Loading delicious recipes...</p>
//                 </div>
//             </div>
//         );
//     }
//
//     // ✅ Error State
//     if (error) {
//         return (
//             <div className="flex items-center justify-center min-h-[400px]">
//                 <div className="text-center px-4">
//                     <svg className="w-16 h-16 text-red-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                     </svg>
//                     <p className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">Oops! Something went wrong</p>
//                     <p className="text-gray-500 dark:text-gray-400 mb-4">{error}</p>
//                     <button
//                         onClick={handleRefresh}
//                         className="px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                     >
//                         Try Again
//                     </button>
//                 </div>
//             </div>
//         );
//     }
//
//     // ✅ Recipe Detail View
//     if (selectedRecipe) {
//         return (
//             <RecipeDetail
//                 recipe={selectedRecipe}
//                 onBack={handleBack}
//                 isBookmarked={isBookmarked(selectedRecipe.recipeId)}
//                 onToggleBookmark={() => toggleBookmark(selectedRecipe)}
//             />
//         );
//     }
//
//     // ✅ Main Recipe List View
//     return (
//         <div className="w-full">
//             {/* Category Filter Section */}
//             <div className="mb-8">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//                     <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
//                         Browse by Category
//                     </h2>
//
//                     <div className="flex gap-2 w-full sm:w-auto">
//                         {/* ✅ Refresh Button */}
//                         <button
//                             onClick={handleRefresh}
//                             title="Refresh recipes"
//                             className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold border-2 border-gray-300 bg-white text-gray-700 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white transition duration-200"
//                         >
//                             <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                             </svg>
//                             <span className="hidden sm:inline">Refresh</span>
//                         </button>
//
//                         {/* Saved Recipes Button */}
//                         <button
//                             onClick={() => {
//                                 setShowBookmarksOnly((prev) => !prev);
//                                 setSelectedCategory('All');
//                             }}
//                             className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition duration-200 flex-1 sm:flex-initial justify-center sm:justify-start
//                             ${showBookmarksOnly
//                                 ? 'bg-yellow-400 border-yellow-400 text-white shadow-lg'
//                                 : 'bg-white border-gray-300 text-gray-700 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
//                             }`}
//                         >
//                             <svg
//                                 className={`w-5 h-5 transition-all duration-200 flex-shrink-0
//                                 ${showBookmarksOnly
//                                     ? 'fill-white stroke-white'
//                                     : 'fill-none stroke-current'
//                                 }`}
//                                 viewBox="0 0 24 24"
//                                 strokeWidth={2}
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <span>Saved Recipes</span>
//                             {bookmarkCount > 0 && (
//                                 <span
//                                     className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0
//                                     ${showBookmarksOnly
//                                         ? 'bg-white text-yellow-500'
//                                         : 'bg-yellow-400 text-white'
//                                     }`}
//                                 >
//                                     {bookmarkCount}
//                                 </span>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//
//                 {/* Category Buttons */}
//                 {!showBookmarksOnly && (
//                     <div className="flex flex-wrap gap-3">
//                         {categories.map((category, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => setSelectedCategory(category)}
//                                 className={`px-6 py-3 rounded-xl font-semibold transition duration-200 ${
//                                     selectedCategory === category
//                                         ? 'bg-[#004c86] text-white dark:text-gray-900 shadow-lg transform scale-105 dark:bg-white'
//                                         : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white'
//                                 }`}
//                             >
//                                 {category}
//                             </button>
//                         ))}
//                     </div>
//                 )}
//             </div>
//
//             {/* Recipe Count Info */}
//             <div className="mb-3 flex items-center justify-between">
//                 <p className="text-lg text-gray-600 dark:text-gray-400">
//                     {showBookmarksOnly ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             saved recipes
//                         </>
//                     ) : selectedCategory === 'All' ? (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes
//                         </>
//                     ) : (
//                         <>
//                             Showing{' '}
//                             <span className="font-bold text-navy-700 dark:text-white">
//                                 {filteredRecipes.length}
//                             </span>{' '}
//                             recipes in{' '}
//                             <span className="font-bold text-[#004c86] dark:text-white">
//                                 {selectedCategory}
//                             </span>
//                         </>
//                     )}
//                 </p>
//             </div>
//
//             {/* Appliance Promo Banner */}
//             {!showBookmarksOnly && selectedCategory !== 'All' && (
//                 <div className="mb-6 bg-gradient-to-r from-[#004c86] to-[#0062a8] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
//                     <div className="flex items-center gap-4">
//                         <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
//                             <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
//                                 <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
//                             </svg>
//                         </div>
//                         <div className="text-white">
//                             <h3 className="font-bold text-lg">
//                                 Make all {selectedCategory} recipes with Crompton
//                             </h3>
//                             <p className="text-sm text-white/80">
//                                 Get the perfect appliance for your kitchen
//                             </p>
//                         </div>
//                     </div>
//                     <a
//                         href={getApplianceLink(selectedCategory)}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="bg-white text-[#004c86] px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap w-full md:w-auto text-center"
//                     >
//                         Shop {selectedCategory} →
//                     </a>
//                 </div>
//             )}
//
//             {/* Recipe Cards Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
//                 {currentRecipes.map((recipe, index) => (
//                     <div
//                         key={recipe.recipeId || index}
//                         className="flex flex-col bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl dark:bg-navy-800 dark:border-navy-700"
//                     >
//                         {/* Recipe Image */}
//                         <div className="relative w-full h-48 sm:h-52 md:h-56 bg-gray-100 dark:bg-navy-700">
//                             <img
//                                 className="w-full h-full object-cover"
//                                 src={recipe.imageUrl || NoImageFound}
//                                 alt={recipe.recipeName || 'Recipe'}
//                                 onError={(e) => {
//                                     e.target.src = NoImageFound;
//                                 }}
//                             />
//                             <div className="absolute top-3 right-3 bg-[#004c86] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[60%] truncate">
//                                 {recipe.categoryName}
//                             </div>
//                         </div>
//
//                         {/* Card Content */}
//                         <div className="flex flex-col p-4 sm:p-5 flex-grow">
//                             <div className="flex items-start justify-between gap-2 mb-2">
//                                 <h3 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white line-clamp-2 flex-1 leading-snug">
//                                     {recipe.recipeName}
//                                 </h3>
//
//                                 {/* Bookmark Button */}
//                                 <button
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         toggleBookmark(recipe);
//                                     }}
//                                     title={isBookmarked(recipe.recipeId) ? 'Remove Bookmark' : 'Save Recipe'}
//                                     className={`
//                                         flex items-center justify-center
//                                         w-8 h-8 sm:w-9 sm:h-9
//                                         rounded-lg
//                                         transition-all duration-200
//                                         shadow-sm
//                                         ${isBookmarked(recipe.recipeId)
//                                         ? 'bg-yellow-400 hover:bg-yellow-500 shadow-yellow-200 dark:shadow-yellow-900'
//                                         : 'bg-gray-100 hover:bg-yellow-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600'
//                                     }
//                                     `}
//                                 >
//                                     <svg
//                                         className={`
//                                             w-4 h-4
//                                             transition-all duration-200
//                                             ${isBookmarked(recipe.recipeId)
//                                             ? 'fill-white stroke-white'
//                                             : 'fill-none stroke-gray-500 dark:stroke-gray-300'
//                                         }
//                                         `}
//                                         viewBox="0 0 24 24"
//                                         strokeWidth={2.5}
//                                     >
//                                         <path
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                             d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                         />
//                                     </svg>
//                                 </button>
//                             </div>
//
//                             {/* Rating */}
//                             <div className="mb-3">
//                                 <StarRating
//                                     rating={recipe.avgRating || 0}
//                                     totalRatings={recipe.totalRatingsCount || 0}
//                                 />
//                             </div>
//
//                             {/* Recipe Details */}
//                             <div className="flex flex-col gap-1.5 mb-4 text-sm">
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🍽️ Servings:</span>
//                                     <span>{recipe.servings || 'N/A'}</span>
//                                 </div>
//                                 {recipe.prepTime && (
//                                     <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                         <span className="font-semibold">⏱️ Prep Time:</span>
//                                         <span>{recipe.prepTime}</span>
//                                     </div>
//                                 )}
//                                 <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
//                                     <span className="font-semibold">🔥 Cook Time:</span>
//                                     <span>{recipe.cookTime || 'N/A'}</span>
//                                 </div>
//                             </div>
//
//                             {/* View Recipe Button */}
//                             <button
//                                 onClick={() => handleSelectRecipe(recipe)}
//                                 className="mt-auto w-full rounded-xl border-2 border-[#004c86] px-4 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-[#004c86] transition duration-200 hover:bg-[#004c80] hover:text-white active:bg-[#004c86] dark:border-white dark:text-white dark:hover:bg-[#004c86] dark:hover:text-white"
//                             >
//                                 View Recipe
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//
//             {/* Empty State */}
//             {filteredRecipes.length === 0 && !loading && (
//                 <div className="text-center py-16">
//                     {showBookmarksOnly ? (
//                         <div className="flex flex-col items-center gap-4 px-4">
//                             <svg
//                                 className="w-16 h-16 text-gray-300 dark:text-gray-600"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                             >
//                                 <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={1.5}
//                                     d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
//                                 />
//                             </svg>
//                             <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
//                                 No saved recipes yet!
//                             </p>
//                             <p className="text-sm text-gray-400 dark:text-gray-500 max-w-xs">
//                                 Click the 🔖 icon on any recipe card to save it here.
//                             </p>
//                             <button
//                                 onClick={() => setShowBookmarksOnly(false)}
//                                 className="mt-2 px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
//                             >
//                                 Browse Recipes
//                             </button>
//                         </div>
//                     ) : (
//                         <p className="text-xl text-gray-500 dark:text-gray-400">
//                             No recipes found!
//                         </p>
//                     )}
//                 </div>
//             )}
//
//             {/* Pagination */}
//             {filteredRecipes.length > itemsPerPage && (
//                 <>
//                     <div className="flex items-center justify-center gap-1 sm:gap-2 mt-8 flex-wrap">
//                         <button
//                             onClick={handlePrevious}
//                             disabled={currentPage === 1}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === 1
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Previous
//                         </button>
//
//                         <div className="flex gap-1 sm:gap-2 flex-wrap justify-center">
//                             {[...Array(totalPages)].map((_, index) => {
//                                 const pageNumber = index + 1;
//                                 if (
//                                     pageNumber === 1 ||
//                                     pageNumber === totalPages ||
//                                     (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
//                                 ) {
//                                     return (
//                                         <button
//                                             key={pageNumber}
//                                             onClick={() => handlePageChange(pageNumber)}
//                                             className={`w-9 h-9 rounded-lg font-medium transition duration-200 text-sm
//                                             ${currentPage === pageNumber
//                                                 ? 'bg-[#004c86] text-white'
//                                                 : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:bg-navy-700'
//                                             }`}
//                                         >
//                                             {pageNumber}
//                                         </button>
//                                     );
//                                 } else if (
//                                     pageNumber === currentPage - 2 ||
//                                     pageNumber === currentPage + 2
//                                 ) {
//                                     return (
//                                         <span
//                                             key={pageNumber}
//                                             className="w-9 h-9 flex items-center justify-center text-gray-500 dark:text-gray-400 text-sm"
//                                         >
//                                             ...
//                                         </span>
//                                     );
//                                 }
//                                 return null;
//                             })}
//                         </div>
//
//                         <button
//                             onClick={handleNext}
//                             disabled={currentPage === totalPages}
//                             className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
//                             ${currentPage === totalPages
//                                 ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
//                                 : 'bg-[#004c86] text-white hover:bg-blue-800'
//                             }`}
//                         >
//                             Next
//                         </button>
//                     </div>
//
//                     <div className="text-center mt-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
//                         Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredRecipes.length)} of {filteredRecipes.length} recipes
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };
//
// export default RecipeList;

import React, { useState, useEffect } from 'react';
import RecipeDetail from './RecipeDetail';
// import CommentsModal from './CommentsModel'; // ✅ COMMENTED OUT
import NoImageFound from "../../../../assets/img/nfts/no_image.png";
import useBookmarks from './useBookmarks';

const RecipeList = ({ onRecipeDetailToggle, AllRecipe, onRefresh, isLoading, error }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecipe, setSelectedRecipe] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [showBookmarksOnly, setShowBookmarksOnly] = useState(false);

    // ✅ State for recipes
    const [recipes, setRecipes] = useState([]);

    const { isBookmarked, toggleBookmark, bookmarkCount } = useBookmarks();

    const itemsPerPage = 12;

    // ✅ Update recipes when AllRecipe prop changes
    useEffect(() => {
        if (AllRecipe && AllRecipe.recipes && Array.isArray(AllRecipe.recipes)) {
            console.log('📦 Setting recipes from AllRecipe prop in RecipeList');
            setRecipes(AllRecipe.recipes);
        } else if (AllRecipe && Array.isArray(AllRecipe)) {
            // If AllRecipe is directly an array
            console.log('📦 Setting recipes from AllRecipe array in RecipeList');
            setRecipes(AllRecipe);
        } else {
            console.log('⚠️ AllRecipe is null or invalid, setting empty array');
            setRecipes([]);
        }
    }, [AllRecipe]);

    // Extract unique categories
    const categories = [
        'All',
        ...new Set(
            recipes.map((recipe) => recipe.categoryName || recipe.categoryId).filter(Boolean)
        ),
    ];

    // Filter recipes
    const filteredRecipes = recipes.filter((recipe) => {
        const matchesCategory =
            selectedCategory === 'All' ||
            (recipe.categoryName || recipe.categoryId) === selectedCategory;

        const matchesBookmark = showBookmarksOnly
            ? isBookmarked(recipe.recipeId)
            : true;

        return matchesCategory && matchesBookmark;
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedCategory, showBookmarksOnly]);

    const handleSelectRecipe = (recipe) => {
        setSelectedRecipe(recipe);
        onRecipeDetailToggle(true);
    };

    const handleBack = () => {
        setSelectedRecipe(null);
        onRecipeDetailToggle(false);
    };

    // ✅ Loading State (from parent)
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#004c86] dark:border-white mb-4"></div>
                    <p className="text-lg text-gray-600 dark:text-gray-400">Loading delicious recipes...</p>
                </div>
            </div>
        );
    }

    // ✅ Error State (from parent)
    if (error) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="text-center px-4">
                    <svg className="w-16 h-16 text-red-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-xl font-semibold text-gray-700 dark:text-gray-300 mb-2">Oops! Something went wrong</p>
                    <p className="text-gray-500 dark:text-gray-400 mb-4">{error}</p>
                    <button
                        onClick={onRefresh}
                        className="px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    if (selectedRecipe) {
        return (
            <RecipeDetail
                recipe={selectedRecipe}
                onBack={handleBack}
                isBookmarked={isBookmarked(selectedRecipe.recipeId)}
                onToggleBookmark={() => toggleBookmark(selectedRecipe)}
            />
        );
    }

    // Pagination
    const totalPages = Math.ceil(filteredRecipes.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentRecipes = filteredRecipes.slice(indexOfFirstItem, indexOfLastItem);

    const getApplianceLink = (categoryName) => {
        const applianceLinks = {
            'Nutri Blender': 'https://www.crompton.co.in/collections/mixer-grinder-and-blender',
            'Air Fryer': 'https://www.crompton.co.in/collections/air-fryer',
            'OTG': 'https://www.crompton.co.in/collections/cooking-appliances',
        };
        return applianceLinks[categoryName] || 'https://www.crompton.co.in/';
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // ✅ Star rating component
    const StarRating = ({ rating, totalRatings }) => {
        const validRating = typeof rating === 'number' && !isNaN(rating) ? rating : 0;
        const validTotal = typeof totalRatings === 'number' && !isNaN(totalRatings) ? totalRatings : 0;

        const fullStars = Math.floor(validRating);
        const hasHalfStar = validRating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        return (
            <div className="flex items-center gap-2">
                <div className="flex items-center gap-0.5">
                    {[...Array(fullStars)].map((_, i) => (
                        <svg
                            key={`full-${i}`}
                            className="w-4 h-4 text-yellow-400 fill-current"
                            viewBox="0 0 20 20"
                        >
                            <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                        </svg>
                    ))}

                    {hasHalfStar && (
                        <svg className="w-4 h-4 text-yellow-400" viewBox="0 0 20 20">
                            <defs>
                                <linearGradient id={`half-fill-${validRating}`}>
                                    <stop offset="50%" stopColor="currentColor" />
                                    <stop offset="50%" stopColor="transparent" />
                                </linearGradient>
                            </defs>
                            <path
                                fill={`url(#half-fill-${validRating})`}
                                d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
                            />
                            <path
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="0.5"
                                d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
                            />
                        </svg>
                    )}

                    {[...Array(emptyStars)].map((_, i) => (
                        <svg
                            key={`empty-${i}`}
                            className="w-4 h-4 text-gray-300 dark:text-gray-600"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                        </svg>
                    ))}
                </div>

                <div className="flex items-center gap-1 text-xs">
                    <span className="font-bold text-gray-700 dark:text-gray-300">
                        {validRating > 0 ? validRating.toFixed(1) : '0.0'}
                    </span>
                    <span className="text-gray-500 dark:text-gray-400">
                        ({validTotal})
                    </span>
                </div>
            </div>
        );
    };

    return (
        <div className="w-full">
            {/* Category Filter Section */}
            <div className="mb-8">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
                    <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
                        Browse by Category
                    </h2>

                    <div className="flex gap-2 w-full sm:w-auto">
                        {/* ✅ Refresh Button - calls parent's refresh function */}
                        <button
                            onClick={onRefresh}
                            title="Refresh recipes"
                            className="flex items-center gap-2 px-4 py-2.5 rounded-xl font-semibold border-2 border-gray-300 bg-white text-gray-700 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white transition duration-200"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            <span className="hidden sm:inline">Refresh</span>
                        </button>

                        <button
                            onClick={() => {
                                setShowBookmarksOnly((prev) => !prev);
                                setSelectedCategory('All');
                            }}
                            className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold border-2 transition duration-200 flex-1 sm:flex-initial justify-center sm:justify-start
                            ${showBookmarksOnly
                                ? 'bg-yellow-400 border-yellow-400 text-white shadow-lg'
                                : 'bg-white border-gray-300 text-gray-700 hover:border-yellow-400 hover:text-yellow-500 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-yellow-400'
                            }`}
                        >
                            <svg
                                className={`w-5 h-5 transition-all duration-200 flex-shrink-0
                                ${showBookmarksOnly
                                    ? 'fill-white stroke-white'
                                    : 'fill-none stroke-current'
                                }`}
                                viewBox="0 0 24 24"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
                                />
                            </svg>
                            <span>Saved Recipes</span>
                            {bookmarkCount > 0 && (
                                <span
                                    className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0
                                    ${showBookmarksOnly
                                        ? 'bg-white text-yellow-500'
                                        : 'bg-yellow-400 text-white'
                                    }`}
                                >
                                    {bookmarkCount}
                                </span>
                            )}
                        </button>
                    </div>
                </div>

                {!showBookmarksOnly && (
                    <div className="flex flex-wrap gap-3">
                        {categories.map((category, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedCategory(category)}
                                className={`px-6 py-3 rounded-xl font-semibold transition duration-200 ${
                                    selectedCategory === category
                                        ? 'bg-[#004c86] text-white dark:text-gray-900 shadow-lg transform scale-105 dark:bg-white'
                                        : 'bg-white text-gray-700 border-2 border-gray-300 hover:border-[#004c86] hover:text-[#004c86] dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:border-white'
                                }`}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {/* Recipe Count Info */}
            <div className="mb-3 flex items-center justify-between">
                <p className="text-lg text-gray-600 dark:text-gray-400">
                    {showBookmarksOnly ? (
                        <>
                            Showing{' '}
                            <span className="font-bold text-navy-700 dark:text-white">
                                {filteredRecipes.length}
                            </span>{' '}
                            saved recipes
                        </>
                    ) : selectedCategory === 'All' ? (
                        <>
                            Showing{' '}
                            <span className="font-bold text-navy-700 dark:text-white">
                                {filteredRecipes.length}
                            </span>{' '}
                            recipes
                        </>
                    ) : (
                        <>
                            Showing{' '}
                            <span className="font-bold text-navy-700 dark:text-white">
                                {filteredRecipes.length}
                            </span>{' '}
                            recipes in{' '}
                            <span className="font-bold text-[#004c86] dark:text-white">
                                {selectedCategory}
                            </span>
                        </>
                    )}
                </p>
            </div>

            {/* Appliance Promo Banner */}
            {!showBookmarksOnly && selectedCategory !== 'All' && (
                <div className="mb-6 bg-gradient-to-r from-[#004c86] to-[#0062a8] rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 flex-shrink-0">
                            <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                            </svg>
                        </div>
                        <div className="text-white">
                            <h3 className="font-bold text-lg">
                                Make all {selectedCategory} recipes with Crompton
                            </h3>
                            <p className="text-sm text-white/80">
                                Get the perfect appliance for your kitchen
                            </p>
                        </div>
                    </div>
                    <a
                        href={getApplianceLink(selectedCategory)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white text-[#004c86] px-6 py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap w-full md:w-auto text-center"
                    >
                        Shop {selectedCategory} →
                    </a>
                </div>
            )}

            {/* Recipe Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
                {currentRecipes.map((recipe, index) => (
                    <div
                        key={recipe.recipeId || index}
                        className="flex flex-col bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-2xl dark:bg-navy-800 dark:border-navy-700"
                    >
                        {/* Recipe Image */}
                        <div className="relative w-full h-48 sm:h-52 md:h-56 bg-gray-100 dark:bg-navy-700">
                            <img
                                className="w-full h-full object-cover"
                                src={recipe.imageUrl || NoImageFound}
                                alt={recipe.recipeName || 'Recipe'}
                                onError={(e) => {
                                    e.target.src = NoImageFound;
                                }}
                            />
                            <div className="absolute top-3 right-3 bg-[#004c86] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-lg dark:bg-white dark:text-gray-900 max-w-[60%] truncate">
                                {recipe.categoryName}
                            </div>
                        </div>

                        {/* Card Content */}
                        <div className="flex flex-col p-4 sm:p-5 flex-grow">
                            <div className="flex items-start justify-between gap-2 mb-2">
                                <h3 className="text-base sm:text-lg md:text-xl font-bold text-navy-700 dark:text-white line-clamp-2 flex-1 leading-snug">
                                    {recipe.recipeName}
                                </h3>

                                <div className="flex items-start gap-1.5 flex-shrink-0">
                                    {/* Bookmark Button */}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleBookmark(recipe);
                                        }}
                                        title={isBookmarked(recipe.recipeId) ? 'Remove Bookmark' : 'Save Recipe'}
                                        className={`
                                            flex items-center justify-center
                                            w-8 h-8 sm:w-9 sm:h-9
                                            rounded-lg
                                            transition-all duration-200
                                            shadow-sm
                                            ${isBookmarked(recipe.recipeId)
                                            ? 'bg-yellow-400 hover:bg-yellow-500 shadow-yellow-200 dark:shadow-yellow-900'
                                            : 'bg-gray-100 hover:bg-yellow-50 border border-gray-200 dark:bg-navy-700 dark:border-navy-600 dark:hover:bg-navy-600'
                                        }
                                        `}
                                    >
                                        <svg
                                            className={`
                                                w-4 h-4
                                                transition-all duration-200
                                                ${isBookmarked(recipe.recipeId)
                                                ? 'fill-white stroke-white'
                                                : 'fill-none stroke-gray-500 dark:stroke-gray-300'
                                            }
                                            `}
                                            viewBox="0 0 24 24"
                                            strokeWidth={2.5}
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* ✅ Rating - Using avgRating from API */}
                            <div className="mb-3">
                                <StarRating
                                    rating={recipe.avgRating || 0}
                                    totalRatings={recipe.totalRatingsCount || 0}
                                />
                            </div>

                            {/* Recipe Details */}
                            <div className="flex flex-col gap-1.5 mb-4 text-sm">
                                <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                                    <span className="font-semibold">🍽️ Servings:</span>
                                    <span>{recipe.servings || 'N/A'}</span>
                                </div>
                                {recipe.prepTime && (
                                    <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                                        <span className="font-semibold">⏱️ Prep Time:</span>
                                        <span>{recipe.prepTime}</span>
                                    </div>
                                )}
                                <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                                    <span className="font-semibold">🔥 Cook Time:</span>
                                    <span>{recipe.cookTime || 'N/A'}</span>
                                </div>
                            </div>

                            {/* View Recipe Button */}
                            <button
                                onClick={() => handleSelectRecipe(recipe)}
                                className="mt-auto w-full rounded-xl border-2 border-[#004c86] px-4 py-2 sm:py-2.5 text-sm sm:text-base font-medium text-[#004c86] transition duration-200 hover:bg-[#004c80] hover:text-white active:bg-[#004c86] dark:border-white dark:text-white dark:hover:bg-[#004c86] dark:hover:text-white"
                            >
                                View Recipe
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Empty State */}
            {filteredRecipes.length === 0 && !isLoading && (
                <div className="text-center py-16">
                    {showBookmarksOnly ? (
                        <div className="flex flex-col items-center gap-4 px-4">
                            <svg
                                className="w-16 h-16 text-gray-300 dark:text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M5 3h14a1 1 0 011 1v17l-8-4-8 4V4a1 1 0 011-1z"
                                />
                            </svg>
                            <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
                                No saved recipes yet!
                            </p>
                            <p className="text-sm text-gray-400 dark:text-gray-500 max-w-xs">
                                Click the 🔖 icon on any recipe card to save it here.
                            </p>
                            <button
                                onClick={() => setShowBookmarksOnly(false)}
                                className="mt-2 px-6 py-2.5 bg-[#004c86] text-white rounded-xl font-semibold hover:bg-blue-800 transition"
                            >
                                Browse Recipes
                            </button>
                        </div>
                    ) : (
                        <p className="text-xl text-gray-500 dark:text-gray-400">
                            No recipes found!!
                        </p>
                    )}
                </div>
            )}

            {/* Pagination */}
            {filteredRecipes.length > itemsPerPage && (
                <>
                    <div className="flex items-center justify-center gap-1 sm:gap-2 mt-8 flex-wrap">
                        <button
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                            className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
                            ${currentPage === 1
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
                                : 'bg-[#004c86] text-white hover:bg-blue-800'
                            }`}
                        >
                            Previous
                        </button>

                        <div className="flex gap-1 sm:gap-2 flex-wrap justify-center">
                            {[...Array(totalPages)].map((_, index) => {
                                const pageNumber = index + 1;
                                if (
                                    pageNumber === 1 ||
                                    pageNumber === totalPages ||
                                    (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                                ) {
                                    return (
                                        <button
                                            key={pageNumber}
                                            onClick={() => handlePageChange(pageNumber)}
                                            className={`w-9 h-9 rounded-lg font-medium transition duration-200 text-sm
                                            ${currentPage === pageNumber
                                                ? 'bg-[#004c86] text-white'
                                                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100 dark:bg-navy-800 dark:text-white dark:border-navy-700 dark:hover:bg-navy-700'
                                            }`}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                } else if (
                                    pageNumber === currentPage - 2 ||
                                    pageNumber === currentPage + 2
                                ) {
                                    return (
                                        <span
                                            key={pageNumber}
                                            className="w-9 h-9 flex items-center justify-center text-gray-500 dark:text-gray-400 text-sm"
                                        >
                                            ...
                                        </span>
                                    );
                                }
                                return null;
                            })}
                        </div>

                        <button
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                            className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition duration-200 text-sm sm:text-base
                            ${currentPage === totalPages
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-navy-700 dark:text-gray-600'
                                : 'bg-[#004c86] text-white hover:bg-blue-800'
                            }`}
                        >
                            Next
                        </button>
                    </div>

                    <div className="text-center mt-4 text-sm sm:text-base text-gray-600 dark:text-gray-400">
                        Showing {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredRecipes.length)} of {filteredRecipes.length} recipes
                    </div>
                </>
            )}

            {/* ✅ Comments Modal - COMMENTED OUT (kept for future use) */}
            {/* {showCommentsModal && commentsRecipe && (
                <CommentsModal
                    recipe={commentsRecipe}
                    onClose={handleCloseComments}
                    decryptedToken={decryptedToken}
                    apiBaseUrl={API_BASE_URL}
                />
            )} */}
        </div>
    );
};

export default RecipeList;